import React from "react";
import styled from "styled-components";
import Release from "./release";
import data from "services/data";

const StyledReleases = styled.div`
  border-top: solid 1px ${({ theme }) => theme.borderGray};
  display: flex;
  flex-direction: column;
`;

const createFlags = () => {
  const flags = {};
  data.publishFlagOptions.map((flagOption) => {
    flags[flagOption.value] = flagOption.desc;
    return flagOption;
  });
  return flags;
};

const flags = createFlags();

const Releases = ({
  auth,
  list = [],
  module = "",
  tools = [],
  fileTools = [],
  reload,
}) => {
  return (
    <StyledReleases>
      {list.map((r) => (
        <Release
          key={r.id}
          auth={auth}
          id={r.id}
          publishFlagDesc={flags[r.publishFlag]}
          publishFlag={data.getFlagValueBydesc(flags[r.publishFlag])}
          buildTime={r.buildTime}
          pluginVerHash={r.pluginVerHash}
          publishTime={r.publishTime}
          version={r.version}
          changeInfo={r.changeInfo}
          pluginAppId={r.pluginAppId}
          module={module}
          fileId={r.fileId}
          fileName={r.fileName}
          fileSize={r.fileSize}
          depPluginVerList={r.depPluginVerList}
          tools={tools}
          fileTools={fileTools}
          reload={reload}
          publishSystem={r.publishSystem}
        />
      ))}
    </StyledReleases>
  );
};

export default Releases;
